import {
  loginThunk,
  logoutThunk,
  getMyProfile,
  registerThunk,
  loginMFAThunk,
  updateMyProfile,
  loginByTokenThunk,
  resetPasswordThunk,
  changePasswordThunk,
  clearUserDataAction,
  UploadUserImageThunk,
  fetchRegisterDataAction,
  setRegisterQueryDataAction,
  setResetPasswordEmailThunk,
  setResetPasswordDataAction,
  setResetPasswordEmailAction,
  setChangePasswordQueryDataAction,
  setEditPasswordDataAction,
  editPasswordThunk,
  approveTermsThunk,
  GetConfirmationPhoneCodeThunk,
  verifyPhoneByCodyThunk,
} from './authActions';
import { AuthState } from './authTypes';
import { AUTH_NAMESPACE } from './authReducer';
import { useAppAction, useAppSelector } from '../hooks';

export function useCartSelector<T extends (state: AuthState) => any>(
  selector: T
): ReturnType<T> {
  return useAppSelector((state) => selector(state[AUTH_NAMESPACE]));
}

export const useRegisterData = () =>
  useCartSelector((state) => {
    return state.register;
  });

export const useIsInitialized = () =>
  useCartSelector((state) => {
    return state.isInit;
  });

export const useRegisterQueryData = () =>
  useCartSelector((state) => {
    return state.register?.queryData;
  });

export const useChangePasswordQueryData = () =>
  useCartSelector((state) => {
    return state.changePassword?.queryData;
  });

export const useResetPasswordData = () =>
  useCartSelector((state) => {
    return state.resetPassword;
  });

export const useIsLoggedIn = () =>
  useCartSelector((state) => {
    return state.isLogin;
  });

export const useProfile = () =>
  useCartSelector((state) => {
    return state.profile;
  });

export const useMyCompany = () =>
  useCartSelector((state) => {
    return state.profile?.company;
  });

export const useMyCompanyType = () =>
  useCartSelector((state) => {
    return state.profile?.company?.companyType;
  });

export const useMyBookings = () =>
  useCartSelector((state) => {
    return state.myBookings;
  });

export const usePhoneConfirmationData = () =>
  useCartSelector((state) => {
    return state.phoneConfirmation;
  });

export const useEditPasswordData = () =>
  useCartSelector((state) => {
    return state.editPasswordData;
  });

export const useNeedPhoneConfirmation = () =>
  useCartSelector((state) => {
    return state.phoneConfirmation.needPhoneConfirmation;
  });

export const useFetchRegisterData = () => useAppAction(fetchRegisterDataAction);
export const useRegister = () => useAppAction(registerThunk);
export const useLogin = () => useAppAction(loginThunk);
export const useLoginMFA = () => useAppAction(loginMFAThunk);
export const useChangePassword = () => useAppAction(changePasswordThunk);
export const useEditPassword = () => useAppAction(editPasswordThunk);
export const useLoginByToken = () => useAppAction(loginByTokenThunk);
export const useLogout = () => useAppAction(logoutThunk);
export const useClearUserData = () => useAppAction(clearUserDataAction);
export const useSetRegisterQueryData = () =>
  useAppAction(setRegisterQueryDataAction);
export const useSetChangePasswordQueryData = () =>
  useAppAction(setChangePasswordQueryDataAction);
export const useFetchProfile = () => useAppAction(getMyProfile);
export const useUpdateMyProfile = () => useAppAction(updateMyProfile);
export const useSetResetPasswordEmail = () =>
  useAppAction(setResetPasswordEmailThunk);
export const useSetResetPasswordEmailAction = () =>
  useAppAction(setResetPasswordEmailAction);

export const useSetResetPasswordDataAction = () =>
  useAppAction(setResetPasswordDataAction);

export const useSetEditPasswordDataAction = () =>
  useAppAction(setEditPasswordDataAction);

export const useResetPassword = () => useAppAction(resetPasswordThunk);
export const useUploadUserImage = () => useAppAction(UploadUserImageThunk);
export const useGetPhoneConfirmationCode = () =>
  useAppAction(GetConfirmationPhoneCodeThunk);
export const useVerifyPhoneByCode = () => useAppAction(verifyPhoneByCodyThunk);

export const useTerms = () => useAppAction(approveTermsThunk);
